// 123back-frontend/src/lib/template.mailer.ts

export type MailLang = 'fr' | 'en' | 'pl' | 'es' | 'it' | 'de' | 'pt' | 'cs' | 'nl';
export type MailScenario = 'waybill' | 'reception' | 'control' | 'payment';

type SubjectFn = (vars: any) => string;
type BodyFn = (vars: any) => string;

type Template = {
  subject: SubjectFn;
  body: BodyFn;
};

type Templates = Record<MailScenario, Partial<Record<MailLang, Template>>>;

/** ===== Modèles d'e-mail (FR/EN/PL) ===== */
export const EMAIL_TEMPLATES: Templates = {
  waybill: {
    fr: {
      subject: ({ numPackage }: any) =>
        `Votre bordereau d’expédition - ${numPackage}`,
      body: ({ numPackage, tracking, shippingMethod }: any) =>
`Bonjour,

Vous trouverez ci-joint le bordereau d’expédition pour votre envoi (référence : ${numPackage}).
Vous pouvez également le consulter en ligne sur votre espace : https://123back.eu/mes-envois

Numéro de suivi : ${tracking || '—'} 

${shippingMethod === 'classic' ? 'Vous pouvez déposer votre colis auprès du transporteur indiqué sur le bordereau.' : 'L’enlèvement de votre colis est prévu dès demain par un livreur.'}

Merci d’imprimer le PDF et de le glisser dans le colis.
Pour toute question, répondez simplement à ce message.

Cordialement,
Thomas et l’équipe 123back by S&T France`,
    },

    en: {
      subject: ({ numPackage }: any) =>
        `Your shipping label – ${numPackage}`,
      body: ({ numPackage, tracking }: any) =>
`Hello,

Please find attached the shipping label for your shipment (reference: ${numPackage}).
You can also view it online in your personal space: https://123back.eu/mes-envois

Tracking number: ${tracking || '—'} 

The pickup of your parcel is scheduled for tomorrow by a UPS courier.

Please print the PDF and place it inside the parcel.
If you have any questions, simply reply to this email.

Best regards,
Thomas and the 123back by S&T France team`,
    },

    pl: {
      subject: ({ numPackage }: any) =>
        `List przewozowy – ${numPackage}`,
      body: ({ numPackage, tracking }: any) =>
`Dzień dobry,

W załączniku znajduje się list przewozowy dla Twojej przesyłki (numer referencyjny: ${numPackage}).
Dokument jest również dostępny online w Twojej przestrzeni klienta: https://123back.eu/mes-envois

Numer śledzenia: ${tracking || '—'} 

Odbiór paczki przez kuriera UPS zaplanowany jest na jutro.

Prosimy o wydrukowanie pliku PDF i włożenie go do paczki.
W razie pytań prosimy o odpowiedź na tę wiadomość.

Z poważaniem,
Thomas oraz zespół 123back by S&T France`,
    },
    pt: {
      subject: ({ numPackage }: any) => `A sua guia de transporte – ${numPackage}`,
      body: ({ numPackage, tracking, shippingMethod }: any) =>
`Olá,

Encontra em anexo a guia de transporte para o seu envio (referência: ${numPackage}).
Também pode consultá-la na sua área pessoal: https://123back.eu/mes-envois

Número de seguimento: ${tracking || '—'}

${shippingMethod === 'classic' ? 'Pode entregar a encomenda ao transportador indicado na guia.' : 'A recolha da sua encomenda por um estafeta está prevista para amanhã.'}

Imprima o PDF e coloque-o dentro da encomenda.
Se tiver alguma questão, responda diretamente a este e-mail.

Com os melhores cumprimentos,
Thomas e a equipa 123back by S&T France`,
    },
    cs: {
      subject: ({ numPackage }: any) => `Váš přepravní štítek – ${numPackage}`,
      body: ({ numPackage, tracking, shippingMethod }: any) =>
`Dobrý den,

v příloze naleznete přepravní štítek pro vaši zásilku (reference: ${numPackage}).
Je také dostupný ve vašem zákaznickém prostoru: https://123back.eu/mes-envois

Sledovací číslo: ${tracking || '—'}

${shippingMethod === 'classic' ? 'Zásilku můžete předat dopravci uvedenému na štítku.' : 'Vyzvednutí zásilky kurýrem je naplánováno na zítřek.'}

Vytiskněte PDF a vložte jej do zásilky.
V případě dotazů odpovězte na tento e-mail.

S pozdravem,
Thomas a tým 123back by S&T France`,
    },
    nl: {
      subject: ({ numPackage }: any) => `Uw verzendlabel – ${numPackage}`,
      body: ({ numPackage, tracking, shippingMethod }: any) =>
`Hallo,

In de bijlage vindt u het verzendlabel voor uw zending (referentie: ${numPackage}).
U kunt het ook bekijken in uw persoonlijke omgeving: https://123back.eu/mes-envois

Track-en-tracecode: ${tracking || '—'}

${shippingMethod === 'classic' ? 'U kunt het pakket afgeven bij de vervoerder die op het label staat.' : 'Uw pakket wordt morgen door een koerier opgehaald.'}

Druk de pdf af en plaats deze in het pakket.
Heeft u vragen, beantwoord dan deze e-mail.

Met vriendelijke groet,
Thomas en het team van 123back by S&T France`,
    },
  },

  reception: {
    fr: {
      subject: ({ numPackage }: any) =>
        `Confirmation de réception de votre colis – ${numPackage}`,
      body: () =>
`Bonjour,

Nous vous confirmons avoir bien réceptionné votre colis.

Dans un délai de 10 jours ouvrés, vous recevrez un e-mail contenant un PDF récapitulatif comprenant le détail des pièces rachetées.

Nous restons à votre disposition pour toute information complémentaire.

Cordialement,

Thomas et l’équipe 123back by S&T France`,
    },
    pt: {
      subject: ({ numPackage }: any) => `Confirmação da receção da sua encomenda – ${numPackage}`,
      body: () =>
`Olá,

Confirmamos a receção da sua encomenda.

No prazo máximo de 10 dias úteis, receberá um e-mail com um relatório PDF detalhado das peças recompradas.

Continuamos disponíveis para qualquer informação adicional.

Com os melhores cumprimentos,
Thomas e a equipa 123back by S&T France`,
    },
    cs: {
      subject: ({ numPackage }: any) => `Potvrzení o přijetí zásilky – ${numPackage}`,
      body: () =>
`Dobrý den,

potvrzujeme přijetí vaší zásilky.

Do 10 pracovních dnů obdržíte e-mail s podrobnou zprávou PDF o vykoupených dílech.

V případě dalších dotazů jsme vám k dispozici.

S pozdravem,
Thomas a tým 123back by S&T France`,
    },
    nl: {
      subject: ({ numPackage }: any) => `Bevestiging van ontvangst van uw pakket – ${numPackage}`,
      body: () =>
`Hallo,

Wij bevestigen dat wij uw pakket hebben ontvangen.

Binnen maximaal 10 werkdagen ontvangt u een e-mail met een gedetailleerd pdf-overzicht van de ingekochte onderdelen.

Voor aanvullende informatie staan wij tot uw beschikking.

Met vriendelijke groet,
Thomas en het team van 123back by S&T France`,
    },
  },

  control: {
    fr: {
      subject: ({ numPackage }: any) =>
        `Votre récapitulatif de contrôle – ${numPackage}`,
      body: ({ numPackage }: any) =>
`Bonjour,

Vous trouverez ci-joint le PDF récapitulatif du contrôle qualité relatif à votre dossier ${numPackage}.

Pour plus de simplicité, ce document est également disponible dans votre espace personnel 123back.

Nous vous invitons à vous rendre dans la rubrique “Mes envois” afin d’accepter l’offre :
https://123back.eu/mes-envois

En cas de validation, un accusé de réception du paiement vous sera transmis automatiquement.

Si vous avez la moindre question, notre équipe reste à votre disposition.

Cordialement,
Thomas et l’équipe 123back by S&T France`,
    },

    en: {
      subject: ({ numPackage }: any) =>
        `Your quality control summary – ${numPackage}`,
      body: ({ numPackage }: any) =>
`Hello,

Please find attached the quality control summary PDF for your case ${numPackage}.

For convenience, this document is also available in your personal 123back space.

Please visit the “My shipments” section to validate your decision regarding the offer:
https://123back.eu/mes-envois

Once validated, a payment confirmation will be sent to you automatically.

If you have any questions, our team remains at your disposal.

Best regards,
Thomas and the 123back by S&T France team`,
    },

    pl: {
      subject: ({ numPackage }: any) =>
        `Podsumowanie kontroli jakości – ${numPackage}`,
      body: ({ numPackage }: any) =>
`Dzień dobry,

W załączniku znajduje się plik PDF z podsumowaniem kontroli jakości dotyczącej sprawy ${numPackage}.

Dla wygody dokument jest również dostępny w Twojej przestrzeni klienta 123back.

Prosimy przejść do sekcji „Moje przesyłki”, aby zatwierdzić decyzję dotyczącą oferty:
https://123back.eu/mes-envois

Po zatwierdzeniu otrzymasz automatyczne potwierdzenie płatności.

W razie pytań nasz zespół pozostaje do dyspozycji.

Z poważaniem,
Thomas oraz zespół 123back by S&T France`,
    },
    pt: {
      subject: ({ numPackage }: any) => `Resumo do controlo de qualidade – ${numPackage}`,
      body: ({ numPackage }: any) =>
`Olá,

Encontra em anexo o relatório PDF do controlo de qualidade relativo ao processo ${numPackage}.

Este documento também está disponível na sua área pessoal 123back.

Aceda à secção «Os meus envios» para aceitar a oferta:
https://123back.eu/mes-envois

Após a validação, receberá automaticamente uma confirmação de pagamento.

Se tiver alguma questão, a nossa equipa está à sua disposição.

Com os melhores cumprimentos,
Thomas e a equipa 123back by S&T France`,
    },
    cs: {
      subject: ({ numPackage }: any) => `Souhrn kontroly kvality – ${numPackage}`,
      body: ({ numPackage }: any) =>
`Dobrý den,

v příloze naleznete souhrnnou zprávu PDF o kontrole kvality vašeho případu ${numPackage}.

Dokument je také dostupný ve vašem zákaznickém prostoru 123back.

Přejděte do sekce „Moje zásilky“ a přijměte nabídku:
https://123back.eu/mes-envois

Po potvrzení vám bude automaticky zasláno potvrzení o platbě.

V případě dotazů jsme vám k dispozici.

S pozdravem,
Thomas a tým 123back by S&T France`,
    },
    nl: {
      subject: ({ numPackage }: any) => `Overzicht kwaliteitscontrole – ${numPackage}`,
      body: ({ numPackage }: any) =>
`Hallo,

In de bijlage vindt u het pdf-overzicht van de kwaliteitscontrole voor dossier ${numPackage}.

Dit document is ook beschikbaar in uw persoonlijke 123back-omgeving.

Ga naar “Mijn zendingen” om het aanbod te accepteren:
https://123back.eu/mes-envois

Na bevestiging ontvangt u automatisch een betalingsbevestiging.

Heeft u vragen, dan staat ons team voor u klaar.

Met vriendelijke groet,
Thomas en het team van 123back by S&T France`,
    },
  },

  payment: {
    fr: {
      subject: ({ numPackage }: any) =>
        `Confirmation d’initiation de votre paiement – ${numPackage}`,
      body: ({ amountNet }: any) =>
`Bonjour,

Nous vous confirmons que le paiement de votre commande a été initié.

Montant net versé : ${amountNet} € (après déduction des frais de livraison).

Le règlement est effectué par virement bancaire sur l’IBAN que vous avez renseigné lors de votre inscription.
Le délai de traitement bancaire est généralement de 72 heures ouvrées à compter de cette confirmation.

Si vous ne constatez pas la réception du virement au-delà de ce délai, n’hésitez pas à revenir vers nous.

Cordialement,
Thomas et l’équipe 123back by S&T France`,
    },
    pt: {
      subject: ({ numPackage }: any) => `Confirmação do seu pagamento – ${numPackage}`,
      body: ({ amountNet }: any) =>
`Olá,

Confirmamos que o pagamento da sua encomenda foi iniciado.

Montante líquido pago: ${amountNet} € (após dedução dos custos de envio).

O pagamento é efetuado por transferência bancária para o IBAN indicado no registo.
O prazo bancário é geralmente de 72 horas úteis a partir desta confirmação.

Se não receber a transferência após este prazo, contacte-nos.

Com os melhores cumprimentos,
Thomas e a equipa 123back by S&T France`,
    },
    cs: {
      subject: ({ numPackage }: any) => `Potvrzení platby – ${numPackage}`,
      body: ({ amountNet }: any) =>
`Dobrý den,

potvrzujeme, že platba za vaši objednávku byla zahájena.

Čistá vyplacená částka: ${amountNet} € (po odečtení nákladů na dopravu).

Platba je provedena bankovním převodem na IBAN uvedený při registraci.
Bankovní zpracování obvykle trvá 72 pracovních hodin od tohoto potvrzení.

Pokud platbu po této lhůtě neobdržíte, kontaktujte nás.

S pozdravem,
Thomas a tým 123back by S&T France`,
    },
    nl: {
      subject: ({ numPackage }: any) => `Bevestiging van uw betaling – ${numPackage}`,
      body: ({ amountNet }: any) =>
`Hallo,

Wij bevestigen dat de betaling van uw bestelling is gestart.

Netto uitbetaald bedrag: ${amountNet} € (na aftrek van de verzendkosten).

De betaling gebeurt via bankoverschrijving naar het IBAN dat u bij uw registratie hebt opgegeven.
De bancaire verwerking duurt doorgaans 72 werkuren vanaf deze bevestiging.

Neem contact met ons op als u de overschrijving na deze termijn niet hebt ontvangen.

Met vriendelijke groet,
Thomas en het team van 123back by S&T France`,
    },
  },
};

const fallbackScenario: MailScenario = 'waybill';
const fallbackLang: MailLang = 'fr';

/**
 * Retourne {subject, body} en appliquant le fallback :
 * - si scenario manquant => waybill
 * - si langue manquante => fr
 */
export function fillTemplate(
  scenario: MailScenario,
  lang: MailLang,
  vars: Record<string, any>
) {
  const group = EMAIL_TEMPLATES[scenario] || EMAIL_TEMPLATES[fallbackScenario];
  const tpl = group?.[lang] || group?.[fallbackLang];

  if (!tpl) {
    // sécurité : ne devrait pas arriver
    return { subject: '', body: '' };
  }

  return {
    subject: tpl.subject(vars),
    body: tpl.body(vars),
  };
}
